<template>
  <div>
    <input
      :disabled="editable!=undefined?!editable:false"
      type="number"
      class="text-field small w-input"
      :placeholder="[fname]"
      :value="$parent.info[this.slg]"
      @change="updateParent($event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: "Number",
  props: ["slg", "fname", "editable"],
  data: function() {
    return {};
  },
  methods: {
    updateParent(value) {
      this.$parent.info[this.slg] = parseFloat(value);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>